import React from 'react';
import ReactDOM from 'react-dom';
// BrowserRouter importu kaldırıldı veya yorum satırına alındı
// import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import App from './App';

// App bileşenini BrowserRouter sarmalayıcısından çıkardık
ReactDOM.render(
  <App />,
  document.getElementById('root')
);